import ko from 'knockout';
import templateMarkup from 'raw-loader!./login-view.html';
import DataProvider from '../../app/data-framework/data-provider';

function LoginView(params) {

    var self = this;

    self.dataProvider = params.dataProvider;
    self.route = params.route;
}

  // This runs when the component is torn down. Put here any logic necessary to clean up,
  // for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
  LoginView.prototype.dispose = function() { };
  
  export default { viewModel: LoginView, template: templateMarkup };


